// src/features/exams/exam.slice.ts
// Redux slice to manage local UI state for the Exams & Results module.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { ExamUIState, ExamTabFilter, Exam } from './exam.types'

const initialState: ExamUIState = {
  activeTab: 'ALL',
  searchQuery: '',
  selectedInstitutionId: null,
  selectedStandardId: null,
  isScheduleDrawerOpen: false,
  editingExam: null,
  selectedExamId: null,
  currentPage: 0,
  pageSize: 10,
}

const examSlice = createSlice({
  name: 'examUi',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<ExamTabFilter>) => {
      state.activeTab = action.payload
      state.currentPage = 0 // Reset page on tab filter change
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload
      state.currentPage = 0 // Reset page on query change
    },
    setSelectedInstitutionId: (state, action: PayloadAction<number | null>) => {
      state.selectedInstitutionId = action.payload
      state.currentPage = 0
    },
    setSelectedStandardId: (state, action: PayloadAction<number | null>) => {
      state.selectedStandardId = action.payload
      state.currentPage = 0
    },
    openScheduleDrawer: (state) => {
      state.editingExam = null
      state.isScheduleDrawerOpen = true
    },
    openEditDrawer: (state, action: PayloadAction<Exam>) => {
      state.editingExam = action.payload
      state.isScheduleDrawerOpen = true
    },
    closeScheduleDrawer: (state) => {
      state.isScheduleDrawerOpen = false
      state.editingExam = null
    },
    setSelectedExamId: (state, action: PayloadAction<number | null>) => {
      state.selectedExamId = action.payload
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    resetPage: (state) => {
      state.currentPage = 0
    },
  },
})

export const {
  setActiveTab,
  setSearchQuery,
  setSelectedInstitutionId,
  setSelectedStandardId,
  openScheduleDrawer,
  openEditDrawer,
  closeScheduleDrawer,
  setSelectedExamId,
  setCurrentPage,
  resetPage,
} = examSlice.actions

export default examSlice.reducer
